import React, {Fragment} from 'react';
import {Button} from '../main/Styles/Toolbar.jsx';

import {CONNECTION_STATE} from './StateConstants.jsx';
import PropTypes from 'prop-types';


const StartStep = (props) => {
  StartStep.propTypes = {
    setState: PropTypes.func.isRequired
  };

  const onClickContinue = () => {
    props.setState(CONNECTION_STATE.CONNECTING);
  };

  return (
    <Fragment>
      <div>
        Ensure your scanner&apos;s power is on and the USB cable is connected.<p/>
        Then click Continue
      </div>
      <div>
        &nbsp;<p/>
        <Button variant="contained" color="primary"
          onClick={onClickContinue}
        >
          Continue
        </Button>
      </div>
    </Fragment>
  );
};

export default StartStep;
